/**
 * 01 · The cost of the stack — kept from the CEO concept (the narrative is the
 * strongest part). Figures are industry benchmarks, footnoted as such.
 */
export default function CostOfStack() {
  return (
    <section className="tint">
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-num">01 · The cost of the stack</div>
          <div>
            <h2>
              You are paying for <span className="ph">sprawl</span>, not value.
            </h2>
            <p className="lede">
              The average enterprise runs hundreds of tools that overlap, barely integrate, and
              quietly leak budget. The bigger cost is not the licences. It is the work nobody
              can govern, the data nobody can join up, and the AI nobody can see.
            </p>
          </div>
        </div>
        <div className="grid-3">
          <div className="card">
            <div className="figure">~40%</div>
            <h3>Unused licences</h3>
            <p>
              Seats paid for and never used, across tools with duplicate functionality you
              already own somewhere else.
            </p>
          </div>
          <div className="card">
            <div className="figure">$$$</div>
            <h3>Integration tax</h3>
            <p>
              The recurring cost of wiring disconnected systems together, only to have them
              break with the next update.
            </p>
          </div>
          <div className="card">
            <div className="figure">[ ! ]</div>
            <h3>Ungoverned risk</h3>
            <p>
              Shadow AI: teams pasting company data into tools nobody approved, with no audit
              trail and no way to prove compliance.
            </p>
          </div>
        </div>
        <p className="ai-note" style={{ marginTop: 22 }}>
          Figures are typical industry consolidation benchmarks, not rcrt measurements. Your
          number comes from a discovery session against your contracts.
        </p>
      </div>
    </section>
  );
}
